import { withLayout } from '../../layout';

import FinancialSummaryPage from './financial-summary.page';

export default withLayout(FinancialSummaryPage);
